export var createTargetWatcher = function createTargetWatcher() {
  var target = null;
  return {
    targetWatcher: function targetWatcher(watcherName, fn) {
      target = {
        watcherName: watcherName,
        fn: fn
      };
      target.fn();
      target = null;
    },
    getTarget: function getTarget() {
      return target;
    }
  };
};